import axios from 'axios';
import { DarResponse, DatafordelerAddress, DatafordelerAutocompleteResponse } from './types';
import DatafordelerHelper from './DatafordelerHelper';
import IDataFordererClient from './IDatafordelerClient';

function callDatafordeler<T>(queryUrl: string, query: string): Promise<T> {
  const promise: Promise<T> = axios({
    url: queryUrl,
    method: 'post',
    data: {
      query
    }
  }).then((response) => response.data);

  return promise;
}

function callAutoComplete(text: string, token: string): Promise<DatafordelerAutocompleteResponse> {
  const promise: Promise<DatafordelerAutocompleteResponse> = axios({
    url: 'https://adressevaelger.dk/adresser/soeg',
    method: 'get',
    params: {
      maksimum: 20,
      tekst: text,
      token
    }
  }).then((response) => response.data);

  return promise;
}

export default class DataFordererClient implements IDataFordererClient {
  private apiKey: string = process.env.REACT_APP_DATAFORDELER_API_KEY ?? '';

  private baseUrl: string = 'https://graphql.datafordeler.dk/flexible';

  public FindAddressWithAutocomplete(prefix: string): Promise<DatafordelerAutocompleteResponse> {
    return callAutoComplete(prefix, this.apiKey);
  }

  public async FindAddressDetails(
    darAddressLocalId: string,
    version?: string
  ): Promise<DatafordelerAddress | undefined> {
    const endpointVersion = version ?? 'v1';
    const queryUrl = `${this.baseUrl}/${endpointVersion}?apiKey=${this.apiKey}`;

    const darResponse = await callDatafordeler<DarResponse>(
      queryUrl,
      DatafordelerHelper.createDarAddressBody(darAddressLocalId)
    );

    if (darResponse.data.DAR_Adresse.nodes.length === 0) {
      return undefined;
    }

    const data = darResponse.data.DAR_Adresse.nodes[0];

    return {
      fullAddress: data.adressebetegnelse,
      data: {
        doorNumber: data.doerbetegnelse,
        floorNumber: data.etagebetegnelse,
        buildingNumber: data.adresseHarHusnummer.husnummertekst,
        postalCode: data.adresseHarHusnummer.husnummerHoererTilIPostnummer.postnr,
        cityName: data.adresseHarHusnummer.husnummerHoererTilIPostnummer.navn,
        streetName: data.adresseHarHusnummer.husnummerHoererTilNavngivenVej.vejnavn
      }
    };
  }
}
